<!-- Hero Section -->
<section class="hero-section">
  <div class="w-10/12 sm:w-9/12 mx-auto text-center">
    <h1 class="gradient-heading">{{ "case_studies_page.title" | translate }}</h1>
    <p class="hero-subtitle">{{ "case_studies_page.subtitle" | translate }}</p>
  </div>
</section>

<!-- Aggregate Stats Bar -->
<section class="stats-bar">
  <div class="w-10/12 sm:w-9/12 mx-auto">
    <h2 class="stats-heading gradient-heading">{{ "case_studies_page.stats_title" | translate }}</h2>
    <div class="stats-container">
      <div class="stat-item">
        <span class="stat-number gradient-heading">90%</span>
        <span class="stat-label">{{ "case_studies_page.retention" | translate }}</span>
      </div>
      <div class="stats-divider"></div>
      <div class="stat-item">
        <span class="stat-number gradient-heading">3.2X</span>
        <span class="stat-label">{{ "case_studies_page.expansion" | translate }}</span>
      </div>
    </div>
  </div>
</section>

<!-- Featured Case Studies -->
<section class="featured-section">
  <div class="w-10/12 sm:w-9/12 mx-auto">
    <div class="featured-grid">
      @for (study of featuredStudies; track study.key) {
        <div class="featured-card">
          <div class="featured-card-header">
            <div class="company-logo-wrap">
              <img
                [src]="study.logo"
                [alt]="('case_studies_page.' + study.key + '.title' | translate) + ' logo'"
                class="company-logo"
              />
            </div>
            <span class="industry-badge">
              {{ "case_studies_page." + study.key + ".industry" | translate }}
            </span>
          </div>
          <h3 class="featured-card-title">
            {{ "case_studies_page." + study.key + ".title" | translate }}
          </h3>
          <p class="featured-card-metric gradient-heading">
            {{ "case_studies_page." + study.key + ".metric" | translate }}
          </p>
          <p class="featured-card-description">
            {{ "case_studies_page." + study.key + ".description" | translate }}
          </p>
        </div>
      }
    </div>
  </div>
</section>

<!-- Additional Highlights -->
<section class="additional-section">
  <div class="w-10/12 sm:w-9/12 mx-auto">
    <h2 class="section-title gradient-heading">
      {{ "case_studies_page.additional_title" | translate }}
    </h2>
    <div class="additional-grid">
      @for (study of additionalStudies; track study.key) {
        <div class="additional-card">
          <h4 class="additional-card-title">
            {{ "case_studies_page." + study.key + ".title" | translate }}
          </h4>
          <p class="additional-card-description">
            {{ "case_studies_page." + study.key + ".description" | translate }}
          </p>
        </div>
      }
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="cta-section">
  <div class="w-10/12 sm:w-9/12 mx-auto text-center">
    <app-get-demo class="block max-w-md mx-auto"></app-get-demo>
  </div>
</section>
